<script lang="ts">
	export let icon_size = 16;
</script>

<svg
	xmlns="http://www.w3.org/2000/svg"
	width={icon_size}
	height={icon_size}
	viewBox="0 0 32 32"
	><path fill="currentColor" d="M19 10h7v2h-7zm0 5h7v2h-7zm0 5h7v2h-7z" /><path
		fill="currentColor"
		d="M28 5H4a2 2 0 0 0-2 2v18a2 2 0 0 0 2 2h24a2.003 2.003 0 0 0 2-2V7a2 2 0 0 0-2-2M4 7h11v18H4Zm13 18V7h11l.002 18Z"
	/></svg
>
